import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { ItemProduto } from '../api/dto/item-produto';
import { ValorVendaSugeridoDTO } from '../api/dto/valorVendaSugeridoDTO';
import { ItemProdutoVw } from '../api/dto/item-produto-vw';
import { Paginador } from '../api/dto/paginacao/paginador';

@Injectable({
    providedIn: 'root',
})
export class ItemProdutoService {

    constructor(private http: HttpClient) { }

    private url : string = UrlServidor.URL_BASE + 'itens-produtos/';
    
    buscarItemProdutoPorId(id?: number) : Observable<ItemProduto> {
        return this.http.get<ItemProduto>(this.url + id);
    }

    buscarDadosItemProdutoPorId(id?: number) : Observable<ItemProdutoVw> {
        return this.http.get<ItemProdutoVw>(`${this.url}dados-view/${id}`);
    }


    listarPorEmpresaIdEStatus(id?: number, ativo?: boolean): Observable<ItemProduto[]> {
        return this.http.get<ItemProduto[]>(`${this.url}empresa/${id}/ativo/${ativo}`);
    }

    listarPorEmpresaIdEStatusPaginado(id?: number, ativo?: boolean, numeroPagina?: number, inputBusca?: string): Observable<Paginador<ItemProduto>> {
        let params = new HttpParams();
        if(inputBusca){
            params = params.set('busca', inputBusca);
        }
        return this.http.get<Paginador<ItemProduto>>(`${this.url}empresa/${id}/ativo/${ativo}/numero-pagina/${numeroPagina}`, {params});
    }

    listarPorEmpresaId(id?: number): Observable<ItemProduto[]> {
        return this.http.get<ItemProduto[]>(`${this.url}empresa/${id}`);
    }

    listarAtivosPorEmpresa(empresaId?: number, numeroPagina?: number,
        tamanhoPagina?: number, inputBusca?: string): Observable<Paginador<ItemProduto>> {

       let params = new HttpParams();
       if(inputBusca){
           params = params.set('busca', inputBusca);
       }
       if(tamanhoPagina != undefined) {
           params = params.set('tamanho', tamanhoPagina)
       }
       return this.http.get<Paginador<ItemProduto>>(
           `${this.url}empresa/${empresaId}/numero-pagina/${numeroPagina}`, {params});
   }

    listarProdutoVendaPorEmpresaId(empresaId?: number): Observable<ItemProduto[]> {
        return this.http.get<ItemProduto[]>(`${this.url}empresa/${empresaId}/habilitados-venda`);
    }

    listarProdutoBaixaPorEmpresaPaginado(empresaId?: number, numeroPagina?: number,
         tamanhoPagina?: number, inputBusca?: string): Observable<Paginador<ItemProduto>> {

        let params = new HttpParams();
        if(inputBusca){
            params = params.set('busca', inputBusca);
        }
        if(tamanhoPagina != undefined) {
            params = params.set('tamanho', tamanhoPagina)
        }
        return this.http.get<Paginador<ItemProduto>>(
            `${this.url}empresa/${empresaId}/numero-pagina/${numeroPagina}/habilitados-baixa-estoque`, {params});
    }


    codigoExistentePorEmpresa(empresaId?: number, codigo?: string) : Observable<boolean> {
        return this.http.get<boolean>(`${this.url}codigo-existente/empresa/${empresaId}/codigo/${codigo}`);
    }

    valorVendaSugerido(valorVendaSugerido?: ValorVendaSugeridoDTO, ) : Observable<ValorVendaSugeridoDTO> {
        return this.http.post<ValorVendaSugeridoDTO>(`${this.url}valor-venda-sugerido`, valorVendaSugerido);
    }

    salvarItemProduto(item?: ItemProduto): Observable<ItemProduto> {
        return this.http.post<ItemProduto>(this.url, item);
    }

    atualizarItemProduto(id?: number, item?: ItemProduto ): Observable<ItemProduto> {
        return this.http.put<ItemProduto>(this.url + id, item);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(this.url + id);
    }
}

